define(['jquery', 'jquery.transit', 'modernizr', 'container', 'router', 'jump', 'module-game', 'module-roblox'],
    function ($, transit, modernizr, container, router, jumpFactory, moduleGame, moduleRoblox) {

        return (function () {

            const name = 'game';

            const model = container.getBaseModel(name);
            const view = container.getBaseView(name);
            const jump = jumpFactory.create();

            //const pubSub = container.getPublishSubscribe();
            /* model */

            model.publicVars = {};

            model.privateVars = {};

            model.methods = {};

            /* view */

            view.publicVars = {
            };

            view.privateVars = {
                items: new Map(),
                canNavigateAction: 0,
                currentMenuItem: 'game',
                targetSection: '',
                itemsKeys: [],
            };

            view.startup = function () {
                view.privateVars.items.set('game', {
                    init: false,
                    module: moduleGame,
                    config: view.publicVars.moduleGameConfig,
                    callbacks: {

                    }
                });

                view.privateVars.itemsKeys.push('game');

                view.privateVars.items.set('roblox', {
                    init: false,
                    module: moduleRoblox,
                    config: view.publicVars.moduleRobloxConfig,
                    callbacks: {

                    }
                });

                view.privateVars.itemsKeys.push('roblox');

                if (view.publicVars.gameDetails !== 'false') {
                    router.disable();
                }

                if (view.publicVars.robloxDetails !== 'false') {
                    router.disable();
                }

                if (view.publicVars.startModule != '' && view.publicVars.startModule != 'game') {
                    view.methods.performNavigate(view.publicVars.startModule, {
                        slug: view.publicVars.startModuleSlug,
                        slugCustom: view.publicVars.startModuleSlugCustom,
                        disableTrack: true,
                        fireAnim: 1
                    });
                } else if (view.publicVars.startModule === 'game') {
                    view.methods.handleCurrentScrollPosition();
                }

                for (let [key, value] of view.privateVars.items) {
                    const systemCurrentScroll = $(document).scrollTop();
                    var targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                    view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);
                }
            };

            view.bind = function () {
                $(window).on('beforeunload', function () {
                    if (view.privateVars.currentMenuItem != 'game' && view.privateVars.currentMenuItem != '') {

                        let pos;
                        pos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + view.privateVars.currentMenuItem).offset();
                        //window.history.replaceState({}, "", "#");
                        $(window).scrollTop(pos.top);
                    }
                });

                $(window).scroll(function () {

                    let ticking = false;

                    if (view.privateVars.canNavigateAction === 0) {

                        if (!ticking) {
                            window.requestAnimationFrame(function () {
                                view.methods.handleCurrentScrollPosition();
                                ticking = false;
                            });
                        }
                        ticking = true;
                    }
                });

                $(window).resize(() => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(window).on('orientationchange', () => {
                    view.methods.handleCurrentScrollPosition();
                });

                $(view.publicVars.cssId.layout.canNavigateCls).click(function () {
                    var target = container.getData($(this)[0], 'target');

                    container.msg('system - navigate target ' + target);

                    view.methods.performNavigate(target, {fireAnim: 1 });
                });
            };

            view.methods = {
                handleCurrentScrollPosition: () => {

                    const systemCurrentScroll = $(document).scrollTop();

                    let currentMenu = '';

                    for (let [key, value] of view.privateVars.items) {

                        if(systemCurrentScroll == 0) {
                            currentMenu = key;
                            break;
                        }

                        const targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + key).offset();

                        view.methods.handleModuleInit(systemCurrentScroll, key, targetPos);

                        let modifier = 200;

                        if ((targetPos.top - modifier) < systemCurrentScroll) {
                            currentMenu = key;
                        }
                    }

                    if (view.privateVars.currentMenuItem !== currentMenu && currentMenu !== '') {
                        view.privateVars.currentMenuItem = currentMenu;

                        const metaTitle = container.getData($(view.publicVars.cssId.layout.navigateTargetId + '-' + currentMenu)[0], 'meta.title');

                        let targetUrl = view.publicVars.baseUrl + '' + view.privateVars.items.get(currentMenu).config.view.slug;

                        router.route(targetUrl, metaTitle, {});
                    }
                },

                handleModuleInit: (currentScroll, key, targetPos) => {

                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {
                        const rect = $(view.publicVars.cssId.layout.navigateWrapperTargetId + '-' + key)[0].getBoundingClientRect();
                        const scrollPlusWindowHeight = $(window).height() + currentScroll;

                        if ((targetPos.top - 200) < scrollPlusWindowHeight &&
                            (scrollPlusWindowHeight < (targetPos.top + rect.height) || currentScroll < (targetPos.top + rect.height))) {

                            view.methods.fireModuleStart(key);
                        }
                    }

                },

                fireModuleStart: (key) => {
                    if (view.privateVars.items.get(key).module && view.privateVars.items.get(key).init === false) {

                        view.privateVars.items.get(key).init = true;
                        view.privateVars.items.get(key).module.init(
                            view.privateVars.items.get(key).config,
                            view.privateVars.items.get(key).callbacks
                        );
                    }
                },

                performNavigate: (target, options) => {

                    view.privateVars.targetSection = target;

                    view.methods.fireModuleStart(target);

                    $('html, body').finish();

                    let easing = (options && options.easing) || 'easeInOutExpo';

                    const masterSpeed = (options && options.speed !== undefined && options.speed >= 0) ? options.speed : '';

                    const modifier = '0';
                    var speed = 0;

                    let shouldFireAnim = (options && options.fireAnim) || 0;

                    view.privateVars.canNavigateAction = 1;

                    const systemCurrentScroll = $(document).scrollTop();

                    let targetPos;

                    if(options.detailedJumpTarget) {
                        targetPos = $(options.detailedJumpTarget).offset();
                    } else {
                        targetPos = $(view.publicVars.cssId.layout.navigateTargetId + '-' + target).offset();
                    }


                    var diff = Math.abs(systemCurrentScroll - targetPos.top);

                    if (diff > 1000) {
                        speed = 800 + (diff / 3);

                    } else {
                        speed = 1000;
                    }

                    container.msg('system - diff for navigation ' + diff);

                    if (masterSpeed !== '') {
                        speed = masterSpeed;
                    }

                    container.msg('system - navigation anim speed ' + speed);

                    if (target == view.privateVars.currentMenuItem) {
                        shouldFireAnim = 0;
                    } else {
                        // $(view.publicVars.cssId.layout.headerMenuItemCls).removeClass(view.publicVars.cssId.layout.isActiveCls.substr(1));
                    }

                    if (shouldFireAnim) {
                        if (Modernizr.mq('screen and (max-width: 1024px)')) {
                        } else {
                            //view.methods.performAnim(target, view.privateVars.currentMenuItem, {speed: speed});
                        }
                    }

                    let jumpTarget;
                    let jumpMethod;

                    if(options.detailedJumpTarget) {
                        jumpTarget = options.detailedJumpTarget;
                        jumpMethod = jump.centerTo;
                    } else {
                        jumpTarget = view.publicVars.cssId.layout.navigateTargetId + '-' + target;
                        jumpMethod = jump.jumpTo;
                    }

                    jumpMethod(jumpTarget, {
                        modifier: modifier,
                        easing: easing,
                        speed: speed
                    }, function () {

                        if(options.finishCallback) {
                            options.finishCallback();
                        }

                        // $(view.publicVars.cssId.layout.headerMenuItemCls).removeClass(view.publicVars.cssId.layout.isActiveCls.substr(1));

                        // $('#' + view.publicVars.cssId.layout.headerMenuItemCls.substr(1) + '-' + target)
                        //     .addClass(view.publicVars.cssId.layout.isActiveCls.substr(1));

                        view.privateVars.canNavigateAction = 0;
                        view.privateVars.targetSection = '';

                        if (view.privateVars.currentMenuItem !== target) {
                            view.privateVars.currentMenuItem = target;

                            let moduleSlug = '';
                            let meta = '';

                            if (options.slug) {
                                moduleSlug = '/' + options.slug;

                                if(options.slugCustom) {
                                    moduleSlug = '/' + options.slug + '/' + options.slugCustom;
                                    // moduleSlug = '/' + options.slugCustom;
                                }

                                meta = null;
                            } else {
                                meta = container.getData($(view.publicVars.cssId.layout.navigateTargetId + '-' + target)[0], 'meta.title');
                            }

                            router.route(view.publicVars.baseUrl + '' + view.privateVars.items.get(view.privateVars.currentMenuItem).config.view.slug + moduleSlug, meta, {
                                'disableTrack': (options.disableTrack) ? true : false
                            });
                        }

                        if (shouldFireAnim) {
                            if (Modernizr.mq('screen and (max-width: 1024px)')) {
                            } else {
                                //view.methods.performPostAnim(target, view.privateVars.currentMenuItem, {speed: speed});
                            }
                        }
                    });
                },
            };

            /* custom events */
            //pubSub.subscribe('view/actionShowFormThx', view.methods.actionShowFormThx);
            //pubSub.subscribe('view/showThx', view.methods.showThx);


            /* public methods */
            return {
                init: function (options) {
                    model.init(options);
                    view.init(options);
                }
            };


        })();


    });
